module.exports = __webpack_public_path__ + "img/passkey-logo-blue.390851c9.svg";